/**
 * Build pick-one choice groups from flat NHK catalog items.
 * Color families (same groupId) stay together as one option.
 * Families sharing choiceGroupId become alternatives in one group.
 * Families without choiceGroupId remain standalone required slots.
 */
export function buildNHKChoiceGroups(items) {
  if (!items || items.length === 0) return [];

  // 1) Bucket by color-family groupId
  const colorFamilies = [];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    let found = false;
    for (let j = 0; j < colorFamilies.length; j++) {
      if (colorFamilies[j][0].groupId === item.groupId) {
        colorFamilies[j].push(item);
        found = true;
        break;
      }
    }
    if (!found) colorFamilies.push([item]);
  }

  // 2) Bucket families into choice groups
  const named = new Map();
  const solos = [];

  for (let i = 0; i < colorFamilies.length; i++) {
    const family = colorFamilies[i];
    const cgId = family[0].choiceGroupId;
    if (cgId) {
      if (!named.has(cgId)) {
        named.set(cgId, {
          id: cgId,
          title: family[0].choiceGroupTitle || "Choose one",
          displayOrder: family[0].choiceGroupDisplayOrder != null
            ? family[0].choiceGroupDisplayOrder
            : 0,
          options: []
        });
      }
      named.get(cgId).options.push(family);
    } else {
      solos.push({
        id: `solo-${family[0].groupId}`,
        title: family[0].title,
        displayOrder: 1000000 + i,
        options: [family],
        isSolo: true
      });
    }
  }

  return [...named.values()]
    .sort((a, b) => (a.displayOrder - b.displayOrder) || (a.id - b.id))
    .concat(solos);
}
